define((require) => {
    "use strict";

    const Backbone                = require("backbone");

    /**
     * Model for the text editor.
     *
     * @class TextEditorModel
     * @constructor
     */
    return Backbone.Model.extend("Editor model", {
        defaults: {
            fontSize: 30,
            fontStyle: "normal",
            fontWeight: "400",
            color: "#000000",
            fontFamily: "Arial",
            fontProvider: "standard",
            fontMetadata: {},
            fontVariant: "none",
            lineHeight: 1.4,
            textAlign: "left",
            textDecoration: "none",
            textTransform: "none",
            letterSpacing: 0,
            textShadow: "none",
            nodeName: null
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textEnhancedWidget/textEditor/TextEditorModel.js